import axios from 'axios'
import baseURL from './index.js'
const HTTPS_AXIOS = axios.create()
HTTPS_AXIOS.defaults.baseURL = baseURL.robotUrl
HTTPS_AXIOS.defaults.withCredentials = true
HTTPS_AXIOS.defaults.timeout = 60 * 1000
export default HTTPS_AXIOS



// WEBPACK FOOTER //
// ./src/config/http.js